<ng-template #pdmpVendorsDisplay let-c="close" let-d="dismiss" class="el--popup">
  <div class="modal-header background-white" style="color: #5d636b !important">
    <div class="col-12 row pdmp-header pt-0 pb-0">
      <h4 class="col-3 modal-title">PDMP</h4>
      <!-- Below radio buttons will display based on the vendors selected (only if both vendors are configured) in PDMP Vendor settings. -->
      <div class="col-6 padding--left__6" *ngIf="this.pdmpVendorDetails?.pdmpVendors?.length > 1 && !displaySingleVendorOnly">
        <div class="row p-0 vendor-selection">
            <div class="col-3" *ngFor="let vendor of orderedVendors; let i = index" [ngClass]="{'pe-0': i === 0, 'ps-0': i === (pdmpVendorDetails?.pdmpVendors?.length -1)}">
              <label class="vendor-radio p-0">
                <span class="radio-focus-wrap">
                <input #vendorRadio
                  type="radio" name="vendor" [tabindex]="focusedIndex + 1" [value]="vendor?.vendorId" [checked]="vendorTypeId === vendor?.vendorId" (change)="selectVendor(vendor?.vendorId === pdmpVendorEnums?.Logicoy ? 'logicoy' : 'bamboo')" (keydown)="onRadioKeydown($event, focusedIndex)"/></span>
                <img [src]="vendor?.vendorId === pdmpVendorEnums?.Logicoy ? 'assets/LogiCoy.png' : 'assets/Bamboo.png'"
                  [width]="vendor?.vendorId === pdmpVendorEnums?.Logicoy ? 82 : 80"
                  [height]="vendor?.vendorId === pdmpVendorEnums?.Logicoy ? 42 : 40"
                  [alt]="vendor?.vendorId === pdmpVendorEnums?.Logicoy ? 'LogiCoy' : 'Bamboo Health'"
                  class="vendor-logo"
                />
              </label>
            </div>
        </div>
      </div>
      <div class="col-6 vendor-selection" *ngIf="pdmpVendorDetails?.pdmpVendors?.length === 1 || displaySingleVendorOnly">
        <img [src]="getSingleVendorLogo() ? 'assets/Bamboo.png' : 'assets/LogiCoy.png'"
            [width]="getSingleVendorLogo() ? 80 : 150"
            [height]="getSingleVendorLogo() ? 40 : 45"
            [alt]="getSingleVendorLogo() ? 'Bamboo Health' : 'LogiCoy'"
            class="vendor-logo"
          />
      </div>
      <div class="col-3 text-end pe-0">
        <button #addNotesButton *ngIf="!frmPatOrRxHistory" type="button" id="addNotesBtn" [tabindex]="3" class="col-4 hotkey_primary_icon position-relative" (keydown)="onAddNotesKeydown($event)" (click)="openNotes()">
          <i class="fa-kit" [ngClass]="pdmpNotesExists ? 'fa-notes-filled' : 'fa-notes-line'"></i>
          Add Notes
        </button>
      </div>
    </div>
    <button type="button" [tabindex]="-1" class="close" aria-label="Close" (click)="closeModal()" style="color: #5d636b !important">
        <span aria-hidden="true" class="close-button">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0">
    <div class="eprx--block__content transmit--block p-0">
      <div class="col-12" *ngIf="vendorTypeId === pdmpVendorEnums?.Bamboo">
        <div class="row exprx--common-block">
          <div class="col-6 mb-3">
              <div class="eprx--block__header" style="background-color: #4C2560 !important">
                  <div class="eprx--header__heading">
                      <span>NarxCare Scores</span>
                  </div>
              </div>
              <div class="eprx--block__content">
                <!-- Scrollable container -->
                <div class="narx-scroll">
                  <div class="narx-item" [ngClass]="narxInformation?.narxScores?.length <= 4 ? 'col-3' : ''"
                      *ngFor="let narxScore of narxInformation?.narxScores; let last = last"
                      [ngStyle]="{ 'border-right-style': !last ? 'groove' : 'none' }">
                    <span>{{narxScore?.scoreType}}</span>
                    <strong>{{narxScore?.scoreValue}}</strong>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-6 mb-3">
              <div class="eprx--block__header" style="background-color: #4C2560 !important">
                  <div class="eprx--header__heading">
                      <span>NarxCare Messages</span>
                  </div>
              </div>
              <div class="eprx--block__content">
                <!-- Scrollable container -->
                <div class="narx-scroll">
                  <div class="narx-item" [ngClass]="narxInformation?.narxMessages?.length <= 4 ? 'col-3' : ''"
                      *ngFor="let narxMsg of narxInformation?.narxMessages; let last = last"
                      [ngStyle]="{ 'border-right-style': !last ? 'groove' : 'none' }">
                    <span>{{narxMsg?.messageText}}</span>
                    <strong class="color_red">{{narxMsg?.messageSeverity}}</strong>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- Test Iframe -->
          <iframe
          *ngIf="pdmpIframeUrl"
          id="pdmpFrame"
          [src]="pdmpIframeUrl"
          sandbox="allow-same-origin allow-scripts"
          frameborder="0"
          class="text-center" toolbar="0" width="100%" [height]="vendorTypeId === pdmpVendorEnums?.Logicoy ? '780px' : '650px'">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<app-notes-log  *ngIf="actnType === 'Notes' && !frmPatOrRxHistory"
[IsFromRxSave]="(this.openType === 'manualInvoke' && (this.rxType === 'er' || !this.rxType)) ? false : true" [NotesListBeforeSave]="rxInfo?.value['RxNotes']"
[RxInfo]="rxInfo?.getRawValue()" [NotesFr]="'Rx'"  [OpenAsModal]="true" [IsFromPDMP]="true"
(CloseNotesValue)="actnType = null" (CloseNotesValueList)="actnType = null;getNoteList($event)"></app-notes-log>
<ng-template #errorPDMPModal let-c="close" let-d="dismiss" class="el--popup">
 <div class="modal-header">
  <h4 class="modal-title">Warning!!</h4>
   <button type="button" [tabindex]="-1" class="close" aria-label="Close"  (click)="closeModal()">
       <span aria-hidden="true" class="close-button--equalalign">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="col-12 ps-0">
      <div class="row align-items-center">
        <!-- Icon -->
        <div class="col-3 text-end pe-0">
          <img src="assets/img/pdmp-error.png" width="130" height="100" alt="Error" class="vendor-logo"/>
        </div>
        <!-- Text -->
        <div class="col-9 text-start ps-0">
          <div class="eprx--block__content">
            <!-- <h4 class="mb-2 font-weight-bold">Oops!</h4> -->
            <h6 class="mb-2 font-weight-bold" *ngIf="!errorMessage">We couldn't load your PDMP {{isBambooDefault ? '(Bamboo Health)' : '(Logicoy)'}} report.</h6>
            <h6 class="mb-2 font-weight-bold" *ngIf="errorMessage">PDMP {{isBambooDefault ? '(Bamboo Health)' : '(Logicoy)'}} report cannot be retrieved for the following reason(s):</h6>
            <div class="mb-2 pdmpInformation-msg" *ngIf="errorMessage">
                <div class="padding_0_5rem">{{errorMessage}}</div>
            </div>
            <div>Please access the information through your state portal.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer pe-3 border_top--none">
    <div class="text-center">
      <button  *ngIf="openOtherVendor" #openBtn class="hotkey_primary" appShortcutKey InputKey="o" (click)="reOpenVendorReport()"><b>O</b>
          Open {{otherVendorId === pdmpVendorEnums.Logicoy ? 'Logicoy' : 'Bamboo Health'}} Report
      </button>
      <button #closeBtn class="hotkey_primary" (click)="closeModal()" appShortcutKey InputKey="c">
        <b>C</b> CLOSE
      </button>
    </div>
  </div>
</ng-template>
